import { ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"
import { AktuelleSchicht } from "@/components/AktuelleSchicht"
import { SchichtWoche } from "@/components/SchichtWoche"
import { Karte } from "@/components/ui"

/** Dashboards in ProDash — das Betriebstagebuch liefert die ersten, weitere kommen hinzu. */
const DASHBOARDS = [
  {
    pfad: "/auswertungen/betriebstagebuch",
    titel: "Durchsatz Konti-Verdrängung",
    text: "Betriebstagebuch: Durchsatz NC feucht je NC-Typ, Gebinde, Medium und Jahr; Ausreißer bereinigt.",
  },
  {
    pfad: "/schicht",
    titel: "Proben der laufenden Schicht",
    text: "Betriebstagebuch: Proben der letzten 24 Stunden mit Toleranz-Ampel.",
  },
  {
    pfad: "/stellen",
    titel: "Stellenbesetzung",
    text: "Schichtplanung: welche Stellen je Schicht besetzt sind und welche nicht, Tag für Tag.",
  },
]

/** Startseite: die Dashboards, daneben die aktuelle Schicht und darunter die Schichtwoche nach Plan. */
export function StartPage() {
  return (
    <main className="mx-auto grid max-w-[1260px] gap-[18px] px-4 pb-12 pt-6">
      <div>
        <h1 className="m-0 text-[clamp(24px,3.2vw,32px)] font-semibold leading-tight">ProDash</h1>
        <p className="m-0 mt-1 text-[13px] text-ink2">Dashboards aus der Produktion und die aktuelle Schicht.</p>
      </div>
      <div className="grid items-start gap-[18px] lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
        <Karte titel="Dashboards" className="order-2 lg:order-1">
          <ul className="m-0 grid list-none gap-2 p-0">
            {DASHBOARDS.map((a) => (
              <li key={a.pfad}>
                <Link
                  to={a.pfad}
                  className="group flex items-center gap-3 rounded-lg border border-hair/10 px-3.5 py-3 no-underline hover:border-accent/40 hover:bg-accent/5"
                >
                  <div className="min-w-0 flex-1">
                    <div className="text-[14px] font-semibold text-ink">{a.titel}</div>
                    <div className="text-[12.5px] text-ink2">{a.text}</div>
                  </div>
                  <ChevronRight className="h-4 w-4 shrink-0 text-muted group-hover:text-accent-strong" aria-hidden="true" />
                </Link>
              </li>
            ))}
          </ul>
          <p className="m-0 text-[12px] text-muted">Weitere Dashboards kommen hier dazu.</p>
        </Karte>
        <div className="order-1 lg:order-2">
          <AktuelleSchicht />
        </div>
      </div>
      <SchichtWoche />
    </main>
  )
}
